module.exports = __webpack_public_path__ + "static/tech19.32f0adb2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/carousel/technika/tech19.jpg
// module id = 683
// module chunks = 39862026607597